<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_DETALHAR_COMANDA')">
            <div class="z-1 text-center">
                <div class="text-900 font-bold text-7xl mb-4">Acesso Negado</div>
                <p class="line-height-3 mt-0 mb-5 text-700 text-xl font-medium">Voçê não possui permissão
                    de acesso a esta página</p>
                <p-button [routerLink]="['/apps/caixa']"
                    styleClass="p-button-help font-medium p-button-raised">Voltar</p-button>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_DETALHAR_COMANDA')">
            <form>
                <div class="formgroup" *ngIf="isExibirSpinnerPrincipal()">
                    <div class="flex justify-content-center">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto">
                        <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                    </div>
                </div>
                <div class="formgroup" *ngIf="comanda && !isExibirSpinnerPrincipal()">
                    
                    <div class="p-fluid p-formgrid grid pt-3 px-3">
                        <div class="col-12 card-simple mb-3">
                            <div class="p-fluid p-formgrid grid">
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Data</label>
                                    <label class="label-inferior">{{ comanda.dataComanda |
                                        date:'dd/MM/yyyy' }}</label>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Nº</label>
                                    <label class="label-inferior">{{ comanda.numeroComanda }}</label>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Status</label>
                                    <label class="label-inferior">{{ comanda.statusComanda
                                        }}</label>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Cliente</label>
                                    <label class="label-inferior">{{ comanda.cliente?.nome }}</label>
                                </div>
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">CPF</label>
                                    <label class="label-inferior">{{ comanda.cliente?.cpf | cpfFormat }}</label>
                                </div>
                                
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Saldo Cliente</label>
                                    <label class="label-inferior">{{ comanda.cliente?.saldoConta | currency:'BRL' }}</label>
                                </div>

                               

                            </div>
                            <div class="p-fluid p-formgrid grid">
                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Total Comanda</label>
                                    <label class="label-inferior">{{ valorTotalItensComDesconto | currency:'BRL' }}</label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Total Pago</label>
                                    <label class="label-inferior">{{ totalPagamentos | currency:'BRL'}}</label>
                                </div>

                                <div class="col-12 md:col-2">
                                    <label class="label-superior">Saldo Comanda</label>
                                    <label class="label-inferior">{{ (totalPagamentos - valorTotalItensComDesconto)  | currency:'BRL' }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <p-tabView styleClass="tabview-custom">
                        <p-tabPanel header="comanda">
                            <ng-template pTemplate="header">
                                <i class="pi pi-calendar mr-1"></i>
                                <span>Itens</span>
                            </ng-template>
                            <div class="p-fluid p-formgrid grid pt-3">
                                <div class="w-full mt-3">
                                    <p-table #dt1 [value]="listaItensComanda" dataKey="id" [rows]="10" [rowHover]="true"
                                        [paginator]="false" responsiveLayout="stack" styleClass=" p-datatable-sm">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Descrição</th>
                                                <th>Quantidade</th>
                                                <th>Valor Unitário</th>
                                                <th>Desconto Item</th>
                                                <th>Valor Total</th>
                                                <th>Profissional</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-item>
                                            <tr>
                                                <td>
                                                    <label>{{ item.descricaoItem }}
                                                        <span class="product-badge status-instock mr-1"
                                                            *ngIf="item.pacote">PACOTE</span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <label>{{ item.quantidadeItem }}</label>
                                                </td>
                                                <td>
                                                    <label>{{ item.valorItem | currency:'BRL' }}</label>
                                                </td>
                                                <td>
                                                    <label>{{ item.descontoItem.toFixed(2) }}%</label>
                                                </td>
                                                <td>
                                                    <label>{{ item.quantidadeItem * item.valorItem | currency:'BRL'
                                                        }}</label>
                                                </td>
                                                <td>
                                                    <label>{{ item.profissionalConsulta ? item.profissionalConsulta.nomeProfissional : 'INDEFINIDO' }}</label>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary">
                                            <div class="flex align-items-center justify-content-between">
                                                <div>
                                                    Há {{listaItensComanda ? listaItensComanda.length : 0 }} itens
                                                    inseridos
                                                    na Comanda.
                                                </div>
                                                <div class="flex-column hidden md:flex"
                                                    *ngIf="listaItensComanda.length > 0">
                                                    <span class="text-right">Total: {{ valorTotalItensSemDesconto |
                                                        currency:'BRL' }}</span>
                                                    <span>Total c/ desconto: {{ valorTotalItensComDesconto |
                                                        currency:'BRL' }}</span>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="7">Nenhum registro cadastrado.</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>

                                </div>
                            </div>
                        </p-tabPanel>
                        <p-tabPanel header="pagamento" [disabled]="!comanda" [cache]="false">
                            <ng-template pTemplate="header">
                                <i class="pi pi-dollar mr-1"></i>
                                <span>Pagamento</span>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="p-fluid p-formgrid grid">
                                    <!-- <div class="field col-12 card-simple mt-3">
                                            <div class="flex flex-nowrap justify-content-between align-items-center"
                                                >
                                                <div class="flex align-items-center">

                                                    <div class="flex-column hidden md:flex">
                                                        <span
                                                            class="text-900 font-semibold block">{{comanda?.cliente?.nome}}</span>
                                                        <span
                                                            class="block text-600 text-overflow-ellipsis overflow-hidden white-space-nowrap w-10rem text-sm">Nº
                                                            Comanda: {{comanda?.numeroComanda}}
                                                        </span>
                                                        <span
                                                            class="block text-600 text-overflow-ellipsis overflow-hidden white-space-nowrap w-15rem text-sm">
                                                            Saldo Cliente: {{this.comanda?.cliente?.saldoConta |
                                                            currency:'BRL' }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="flex align-items-center">

                                                    <div class="flex-column hidden md:flex">
                                                        <span
                                                            class="text-700 font-semibold ml-auto hidden md:inline"><strong>Total
                                                                Comanda:</strong>
                                                            {{totalItensComanda | currency:'BRL'}}
                                                        </span>
                                                        <span
                                                            class="text-700 font-semibold ml-auto hidden md:inline"><strong>Total
                                                                Pago:</strong>
                                                            {{totalPagamentos | currency:'BRL'}}
                                                        </span>
                                                        <span
                                                            class="text-700 font-semibold ml-auto hidden md:inline"><strong>Saldo:</strong>
                                                            {{saldoComanda | currency:'BRL'}}
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                    </div> -->


                                    <div class="w-full">
                                        <p-table #dt2 [value]="listaPagamentos" dataKey="id" [rows]="10"
                                            [rowHover]="true" [paginator]="false" responsiveLayout="stack"
                                            styleClass=" p-datatable-sm">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Valor</th>
                                                    <th>Documento</th>
                                                    <th>Prazo</th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-item let-i="rowIndex">
                                                <tr>
                                                    <td>
                                                        <label>{{ item.tipoPagamento.descricao }}</label>
                                                    </td>
                                                    <td>
                                                        <label>{{ item.valorFluxo | currency:'BRL' }}</label>
                                                    </td>
                                                    <td>
                                                        <label>{{ item.identificacao }}</label>
                                                    </td>
                                                    <td>
                                                        <label>{{ item.prazo }} dias</label>
                                                    </td>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="summary">
                                                <div class="flex align-items-center justify-content-between">
                                                    <div>
                                                        Há {{listaPagamentos.length}} pagamentos realizados.
                                                    </div>
                                                    <div>
                                                        Total: {{ totalPagamentos | currency:'BRL' }}
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="emptymessage">
                                                <tr>
                                                    <td colspan="7">Não há pagamentos cadastrados.</td>
                                                </tr>
                                            </ng-template>
                                        </p-table>

                                    </div>
                                </div>
                            </ng-template>
                        </p-tabPanel>
                    </p-tabView>

                    <div class="p-fluid p-formgrid grid justify-content-end">
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem mt-2" routerLink="/apps/caixa"></button>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </div>
</div>